/**
 * Wada Sanzo-inspired color palette
 * Shared across the entire app for consistent part coloring.
 */

export const PALETTE = [
  { name: 'Vermillion',    hex: '#C73B3B', threeHex: 0xC73B3B },
  { name: 'Indigo',        hex: '#2B5F8A', threeHex: 0x2B5F8A },
  { name: 'Olive',         hex: '#6B8E5A', threeHex: 0x6B8E5A },
  { name: 'Ochre',         hex: '#D4A843', threeHex: 0xD4A843 },
  { name: 'Plum',          hex: '#8B4F8B', threeHex: 0x8B4F8B },
  { name: 'Burnt Orange',  hex: '#C47A3C', threeHex: 0xC47A3C },
  { name: 'Teal',          hex: '#4A8B8B', threeHex: 0x4A8B8B },
  { name: 'Chartreuse',    hex: '#A3B54A', threeHex: 0xA3B54A },
  { name: 'Iris',          hex: '#7B5CB7', threeHex: 0x7B5CB7 },
  { name: 'Rose',          hex: '#CB6882', threeHex: 0xCB6882 },
  { name: 'Forest',        hex: '#3D7A5F', threeHex: 0x3D7A5F },
  { name: 'Amber',         hex: '#D49B3C', threeHex: 0xD49B3C },
  { name: 'Steel Blue',    hex: '#5B7FA5', threeHex: 0x5B7FA5 },
  { name: 'Sienna',        hex: '#9C6B4A', threeHex: 0x9C6B4A },
  { name: 'Sage',          hex: '#6BA38B', threeHex: 0x6BA38B },
  { name: 'Brick',         hex: '#B5534B', threeHex: 0xB5534B },
  { name: 'Slate',         hex: '#4B6B8A', threeHex: 0x4B6B8A },
  { name: 'Apple',         hex: '#8AA644', threeHex: 0x8AA644 },
  { name: 'Mauve',         hex: '#A85C7B', threeHex: 0xA85C7B },
  { name: 'Seafoam',       hex: '#5CA0A0', threeHex: 0x5CA0A0 },
  { name: 'Copper',        hex: '#C4853C', threeHex: 0xC4853C },
  { name: 'Grape',         hex: '#6B5B8A', threeHex: 0x6B5B8A },
  { name: 'Moss',          hex: '#8B8B3D', threeHex: 0x8B8B3D },
  { name: 'Terra Cotta',   hex: '#B07050', threeHex: 0xB07050 },
];

/**
 * Deterministically map a part ID to a color index.
 * Uses a simple string hash so the same ID always gets the same color.
 */
export function getPartColor(partId) {
  const idStr = String(partId);
  const hashCode = Array.from(idStr).reduce(
    (acc, ch) => ((acc << 5) - acc + ch.charCodeAt(0)) | 0,
    0
  );
  const index = Math.abs(hashCode) % PALETTE.length;
  return {
    index,
    hex: PALETTE[index].hex,
    threeHex: PALETTE[index].threeHex,
    name: PALETTE[index].name,
  };
}
